import api from "./api";

export interface ClientErrorPayload {
  type: string;
  message: string;
  stack?: string;
  url?: string;
  user_agent?: string;
  context?: Record<string, unknown>;
}

export async function reportClientError(payload: ClientErrorPayload): Promise<void> {
  try {
    await api.post("/client-errors", payload);
  } catch {
    // never throw from error reporting
  }
}
